import { EdfPlayers } from '../directus';
import { PlayerCareer } from '@/components/types';

export default function mapPlayersToPlayerCareer(data: Array<EdfPlayers>): Array<PlayerCareer> {
  return data.map(({ id, first_name, last_name, height, player_points, player_selections }) => ({
    id,
    firstName: first_name || '',
    lastName: last_name || '',
    height: height,
    playerPoints: player_points || 0,
    playerSelections: player_selections || 0,
  }));
}
